import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { LOCALSTORAGE_TOKEN } from 'src/app/utils/cst';
import { NgxSpinnerService } from 'ngx-spinner';
import { TranslateService } from '@ngx-translate/core';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-re-login-modal',
  templateUrl: './re-login-modal.component.html',
  styleUrls: ['./re-login-modal.component.less'],
})
export class ReLoginModalComponent {
  @ViewChild('email') emailField: ElementRef;
  @ViewChild('password') passwordField: ElementRef;

  mail: string;
  pass: string;

  // *******************************************************************************************************************
  // INITIALIZATION
  // *******************************************************************************************************************

  constructor(
    public activeModal: MatDialogRef<ReLoginModalComponent>,
    private toast: ToastrService,
    private spinner: NgxSpinnerService,
    private translate: TranslateService,
    private authService: AuthService,
    @Inject(DOCUMENT) public document: Document
  ) {
    this.activeModal.afterOpened().subscribe(() => {
      this.emailField.nativeElement.focus();
    });
    this.activeModal.afterClosed().subscribe((success: boolean) => {
      if (!success) {
        this.authService.logOut();
      }
    });
  }

  onAuth() {
    this.spinner.show();
    this.authService
      .login(this.mail, this.pass, this.translate.currentLang)
      .subscribe({
        next: () => {
          this.activeModal.close(true);
          this.spinner.hide();
        },
        error: () => {
          this.toast.error(this.translate.instant('authentification.error'));
          this.spinner.hide();
        },
      });
  }

  onCancel() {
    this.activeModal.close(false);
  }
}
